import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class ChatControls extends PureComponent {
  render() {
    return (
      <div className="chat-ctrls form-edit-container blue">
        {this.props.children}
      </div>
    );
  }
}

ChatControls.propTypes = {
  children: PropTypes.any,
};

export default ChatControls;
